<div mat-dialog-content style="max-height: 85vh;">
  <img class="image" [src]="imageUrl"/>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button color="warn" [mat-dialog-close]>Close</button>
</div>
